import { JSX } from "@emotion/react/jsx-runtime";
import { ReactNode } from "react";
import { Typography } from "@mui/material";
import { DynamicContentText } from "../DynamicContentComponent";

export interface DynamicTextParagraphProps {
  text: String;
  childElements?: ReactNode[]; 
}

export const DynamicTextParagraph = ({ text, childElements }: DynamicContentText): JSX.Element => {
    return <Typography variant="body1" component="p">
      {text}
      {childElements || ''}
    </Typography>
}